import styled from 'styled-components';
import { Colors } from '../../values/colors';

export const DropdownContainer = styled.div`
  position: relative;
  margin-left: 2rem;
`;

export const DropdownButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: ${Colors.primaryColor};
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 4px;
  min-width: 200px;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);

  a {
    display: block;
    padding: 0.75rem 1rem;
    color: white;
    text-decoration: none;
    font-weight: 800;
    border-bottom: 1px solid rgba(255,255,255,0.1);

    &:hover {
      background: rgba(255,255,255,0.1);
    }

    &:last-child {
      border-bottom: none;
    }

    &.active {
      background: rgba(255,255,255,0.2);
    }
  }
`;